
const appConfig = {
  drupal: {
    host: process.env.REACT_APP_DRUPAL_HOST
  }
}

export default appConfig
